import { Chip, type ChipProps } from '~/shared/components/Chip';
import { getDisciplineIntent } from './util';
import { DisciplineOptions } from '@generated';
import { cn } from '~/shared/components/utils';

export function DisciplineChip({
	disciplineId,
	useAbbreviation = true,
	className,
	...props
}: { disciplineId: number; useAbbreviation?: boolean; label?: string } & Omit<ChipProps, 'label'>) {
	const discipline = DisciplineOptions.find(d => d.id === disciplineId);
	if (!discipline) {
		throw new Error(`Discipline with id ${disciplineId} not found`);
	}
	const label = props.label ? props.label : useAbbreviation ? discipline.abbreviation : discipline.label;
	return (
		<Chip
			appearance="outline"
			className={cn('rounded-full py-1.5', className)}
			intent={getDisciplineIntent(disciplineId)}
			{...props}
			label={label}
		/>
	);
}
